import { useEffect, useRef, useState } from 'react';
import { ApiError } from '../lib/api';
import { connectLive, LiveEvent } from '../lib/live';
import { leaveRestaurant, staffSession } from '../lib/owner';

/** The restaurant session for staff screens + a live connection; sends the user back to /owner if it expired. */
export function useStaff(onEvent: (e: LiveEvent) => void, onReconnect: () => void) {
  const [s] = useState(staffSession);
  const [online, setOnline] = useState(true);
  const ev = useRef(onEvent);
  const rc = useRef(onReconnect);
  ev.current = onEvent;
  rc.current = onReconnect;
  useEffect(() => {
    if (!s) { leaveRestaurant(); return; }
    return connectLive(s.token, (e) => ev.current(e), setOnline, () => rc.current());
  }, [s]);
  return { s, online };
}

export function handleAuthError(e: unknown) {
  if (e instanceof ApiError && (e.status === 401 || e.status === 403)) leaveRestaurant();
}
